import * as React from "react";
import { SettingsContext } from "../context/SettingsContext";
import { Actions, ManageableQuickscanData } from "../types";
import { QuickscanDataContext } from "../context/QuickscanDataContext";

export const StepThree = () => {

    const settings = React.useContext(SettingsContext);
    const [quickscanDataState, quickscanDataDispatch] = React.useContext<ManageableQuickscanData>(QuickscanDataContext);

    console.log(quickscanDataState.quickscan.amount);

    return <div className={'c-quickscan__form-group'}>
        <div className={'c-form__row'}>
        <div className={`c-quickscan__form-field ${quickscanDataState.validation.fields.amount ? '' : 'c-form__field--invalid'}`}>
            <label htmlFor="field-amount" className="c-form__label">Gewenste investeringsbedrag</label>
            <input type="text" id="field-amount" name="amount"
                   className={'c-form__field c-form__field--half c-form__input-text'}
                   value={Number.isNaN(quickscanDataState.quickscan.amount) ? 0 : quickscanDataState.quickscan.amount}
                   onChange={(e) => {
                       quickscanDataDispatch({
                           type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                           payload: {
                               quickscan: {
                                   ...quickscanDataState.quickscan,
                                   amount: parseInt(e.target.value) || 0
                               }
                           }
                       })
                   }}/>
        </div>
        <div className={' c-quickscan__form-field'}>
            <label htmlFor="field-period" className="c-form__label">Gewenste investeringsperiode</label>
            { settings.type === 'Solo' ? (
                <select id={'field-period'}
                        name={'period'}
                        className="c-form__field c-form__field--half c-form__select c-form__input-text"
                        value={quickscanDataState.quickscan.period}
                        onChange={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                payload: {
                                    quickscan: {
                                        ...quickscanDataState.quickscan,
                                        period: e.target.value
                                    }
                                }
                            })
                        }}>
                    <option>2 jaar</option>
                    <option>3 jaar</option>
                    <option>4 jaar</option>
                </select>
            ) : (
                <select id={'field-period'}
                        name={'period'}
                        className=" c-form__field c-form__field--half c-form__select"
                        value={quickscanDataState.quickscan.period}
                        onChange={(e) => {
                            quickscanDataDispatch({
                                type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                                payload: {
                                    quickscan: {
                                        ...quickscanDataState.quickscan,
                                        period: e.target.value
                                    }
                                }
                            })
                        }}>
                    <option>2 jaar</option>
                    <option>3 jaar</option>
                    <option>4 jaar</option>
                    <option>5 jaar</option>
                </select>
            )}
        </div>
        </div>
        <div className={'c-form__row'}>
        <div className={`c-quickscan__form-field--full c-quickscan__form-field ${quickscanDataState.validation.fields.equipment ? '' : 'c-form__field--invalid'}`}>
            <label htmlFor="field-equipment" className="c-form__label">Omschrijving gewenste productie- en/of ontwikkelingsapparatuur
                (o.a. functie, commercieel verkrijgbaar of specifieke bouw, locatie in Nederland).</label>
            <textarea id="field-equipment" name="equipment"
                      className={'c-form__field c-form__field--full c-form__input-text c-form__textarea'}
                      defaultValue={quickscanDataState.quickscan.equipment}
                      onChange={(e) => {
                          quickscanDataDispatch({
                              type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                              payload: {
                                  quickscan: {
                                      ...quickscanDataState.quickscan,
                                      equipment: e.target.value
                                  }
                              }
                          })
                      }}></textarea>
        </div>
        </div>
        <div className={'c-form__row'}>
        <div className={`c-quickscan__form-field--full c-quickscan__form-field ${quickscanDataState.validation.fields.alternativeFunding ? '' : 'c-form__field--invalid'}`}>
            <label htmlFor="field-alternative-funding" className="c-form__label">Zijn er alternatieve financieringsbronnen aanwezig?</label>
            <textarea id="field-alternative-funding" name="alternative-funding"
                      className={'c-form__field c-form__field--full c-form__input-text c-form__textarea'}
                      defaultValue={quickscanDataState.quickscan.alternativeFunding}
                      onChange={(e) => {
                          quickscanDataDispatch({
                              type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                              payload: {
                                  quickscan: {
                                      ...quickscanDataState.quickscan,
                                      alternativeFunding: e.target.value
                                  }
                              }
                          })
                      }}></textarea>
        </div>
        </div>
        <div className={'c-form__row'}>
        <div className={`c-quickscan__form-field--full c-quickscan__form-field ${quickscanDataState.validation.fields.otherFinancing ? '' : 'c-form__field--invalid'}`}>
            <label htmlFor="field-other-financing" className="c-form__label">Hoe worden overige opterationele activiteiten gefinancierd?</label>
            <textarea id="field-other-financing" name="other-financing"
                      className={'c-form__field c-form__field--full c-form__input-text c-form__textarea'}
                      defaultValue={quickscanDataState.quickscan.otherFinancing}
                      onChange={(e) => {
                          quickscanDataDispatch({
                              type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                              payload: {
                                  quickscan: {
                                      ...quickscanDataState.quickscan,
                                      otherFinancing: e.target.value
                                  }
                              }
                          })
                      }}></textarea>
        </div>
        </div>
    </div>;

}
